import { render, staticRenderFns } from "./InventoryEdit.vue?vue&type=template&id=5f89a8a7&scoped=true"
import script from "./InventoryEdit.vue?vue&type=script&lang=js"
export * from "./InventoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f89a8a7",
  null
  
)

export default component.exports